import { Component, output } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Where an item mounts the drawer of a kind it stacks — see `DetailDrawerType.stacks`. Placed once
 * in the item's template; the stacked drawer opens over the item, which stays as it was beneath.
 */
@Component({
  selector: 'lp-detail-drawer-stack',
  imports: [RouterOutlet],
  templateUrl: './detail-drawer-stack.component.html',
})
export class DetailDrawerStackComponent {
  /** The stacked drawer is gone, closed or left by a navigation; what it showed may have changed. */
  public readonly closed = output<void>();
}
